import * as tslib_1 from "tslib";
/* tslint:disable */
import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { NodeType } from '../../classes/tree/IBaseNode';
import { NearbyAssetNode } from '../../classes/tree/nodes/NearbyAssetNode';
import { Tree } from '../../classes/tree/tree';
import { environment } from '../../environment';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter } from '../../inputConverter';
import { DistanceUnits } from '../../selectionOptions';
import { LayerService } from '../../services/layer.service';
import { NearbyService } from '../../services/nearby.service';
import { LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
var Graphic;
var PictureMarkerSymbol;
var WebMercatorUtils;
var NearbyComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NearbyComponent, _super);
    function NearbyComponent(_vcr, layerService, LoggingService, nearbyService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.LoggingService = LoggingService;
        _this.nearbyService = nearbyService;
        _this.cdr = cdr;
        _this._active = false;
        _this.activeChange = new EventEmitter();
        _this.openStreetViewWithCoordinates = new EventEmitter();
        _this.openVideoLogWithCoordinates = new EventEmitter();
        _this.status = new EventEmitter();
        _this.NodeType = NodeType;
        _this.asc = true;
        _this.distanceUnits = DistanceUnits;
        _this.distanceDefaultPoly = 0;
        _this.distanceDefaultPtLn = 1000;
        _this.distance = _this.distanceDefaultPtLn;
        _this.distanceDefaultUnit = 'feet';
        _this.distanceMaxDefault = 26400;
        _this.distanceMax = _this.distanceMaxDefault;
        _this.areaMax = 20;
        _this.showPrimary = true;
        _this.showSecondary = true;
        _this._distanceUnit = _this.distanceDefaultUnit;
        _this.loaderText = 'loading...';
        _this.convertMeter = { feet: 3.28084, miles: 0.000621371, kilometers: 0.001, meters: 1, 'nautical-miles': 0.000539957, yards: 1.09361 };
        _this.highlightColor = 'rgba(125, 247, 229, 0.75)';
        _this.highlightSymbols = {
            point: { type: 'simple-marker', outline: { color: _this.highlightColor } },
            polyline: { type: 'simple-line', width: 5, color: _this.highlightColor },
            polygon: { type: 'simple-fill' },
            multipoint: { type: 'simple-marker', outline: { color: _this.highlightColor } },
            default: { type: 'simple-marker' }
        };
        _this.nearbyAssetColor = '#2887c7';
        _this.nearbyAssetSymbols = {
            point: { type: 'simple-marker', color: _this.nearbyAssetColor },
            polyline: { type: 'simple-line', width: 3, color: _this.nearbyAssetColor },
            polygon: { type: 'simple-fill', color: _this.nearbyAssetColor },
            multipoint: { type: 'simple-marker', color: _this.nearbyAssetColor },
            default: { type: 'simple-marker', color: _this.nearbyAssetColor }
        };
        // TODO: It would be better to have a local png pin
        _this.nearbyAssetPointSymbol = {
            url: 'https://static.arcgis.com/images/Symbols/Shapes/BluePin1LargeB.png',
            height: 32,
            width: 32,
            yoffset: 12
        };
        _this.outsideClickHandler = function () {
            _this.toggleDropdown();
        };
        _this.insideClickHandler = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(NearbyComponent.prototype, "graphic", {
        get: function () { return this._graphic; },
        set: function (value) {
            if (this._graphic !== value) {
                this._graphic = value;
                if (value) {
                    this.executeNearbyAssetsTask();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NearbyComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            value = BooleanConverter(value);
            if (this._active !== value) {
                value ? this.activate() : this.deactivate();
                this.activeChange.emit(value);
                this._active = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NearbyComponent.prototype, "distanceUnit", {
        get: function () {
            return this._distanceUnit;
        },
        set: function (unit) {
            this.distance = Math.round(this.distance / this.convertMeter[this._distanceUnit] * this.convertMeter[unit] * 1000) / 1000;
            this.distanceMax = Math.round(this.distanceMax / this.convertMeter[this._distanceUnit] * this.convertMeter[unit] * 1000) / 1000;
            this._distanceUnit = unit;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NearbyComponent.prototype, "searchText", {
        get: function () {
            return this.currentNode ? this.currentNode.data.searchText : this._searchText;
        },
        set: function (value) {
            if (this.currentNode) {
                this.currentNode.data.searchText = value;
            }
            this._searchText = value;
        },
        enumerable: true,
        configurable: true
    });
    NearbyComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.WebMercatorUtils];
                    case 1:
                        WebMercatorUtils = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.activate = function () {
    };
    NearbyComponent.prototype.ngOnDestroy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.deactivate();
                return [2 /*return*/];
            });
        });
    };
    NearbyComponent.prototype.deactivate = function () {
        var _this = this;
        Object.values(this.nearbyService.nearbyLayers).forEach(function (title) { return _this.nearbyService.removeNearbyLayer(title); });
    };
    NearbyComponent.prototype.onMouseEnter = function (node) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.highlightNode(node);
                return [2 /*return*/];
            });
        });
    };
    NearbyComponent.prototype.onMouseLeave = function () {
        this.nearbyService.setNearbyLayer(this.nearbyService.nearbyLayers.highlight, []);
    };
    NearbyComponent.prototype.onDistanceChange = function (distance) {
        if (distance > this.distanceMax) {
            this.distance = this.distanceMax;
        }
        if (distance < 0) {
            this.distance = 0;
        }
    };
    NearbyComponent.prototype.toggleDropdown = function (event) {
        if (event) {
            var target = event.target || event.srcElement || event.currentTarget;
            var dropdown = target.offsetParent.nextElementSibling || target.nextElementSibling;
            dropdown.classList.toggle('show');
            this.openedDropdown = dropdown;
            window.addEventListener('mousedown', this.outsideClickHandler);
            window.addEventListener('dragstart', this.outsideClickHandler);
            this.openedDropdown.addEventListener('mousedown', this.insideClickHandler);
        }
        else {
            this.openedDropdown.classList.toggle('show');
            window.removeEventListener('mousedown', this.outsideClickHandler);
            window.removeEventListener('dragstart', this.outsideClickHandler);
            this.openedDropdown.removeEventListener('mousedown', this.insideClickHandler);
            this.openedDropdown = null;
        }
    };
    NearbyComponent.prototype.toggleAccordion = function (event) {
        var target = event.target || event.srcElement || event.currentTarget;
        var panel = target.nextElementSibling;
        target.classList.toggle('active');
        if (panel.style.display === "block") {
            panel.style.display = "none";
        }
        else {
            panel.style.display = "block";
        }
    };
    NearbyComponent.prototype.onLinkOpen = function () {
        this.toggleDropdown();
    };
    NearbyComponent.prototype.onVideoLogOpen = function (node) {
        this.openVideoLogWithCoordinates.emit(node.data.lngLat);
        this.toggleDropdown();
    };
    NearbyComponent.prototype.onStreetViewOpen = function (node) {
        this.openStreetViewWithCoordinates.emit(node.data.lngLat);
        this.toggleDropdown();
    };
    NearbyComponent.prototype.navigateBack = function (node) {
        node ? this.navigateToNode(node, this.assets) : this.active = false;
    };
    NearbyComponent.prototype.bufferChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeNearbyAssetsTask()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.clearFilter = function () {
        this.searchText = '';
    };
    NearbyComponent.prototype.executeNearbyAssetsTask = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var graphics, _a, pin, buffers, totalArea, buffer, _b, selectionLayer, heightOrWithThreshold, zoomThreshold, error_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 13, 14, 15]);
                        this.loading = true;
                        this.status.emit('loading');
                        graphics = [];
                        _a = this.graphic.geometry.type;
                        switch (_a) {
                            case 'point': return [3 /*break*/, 1];
                            case 'polygon': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        if (!this.graphic.clone) return [3 /*break*/, 3];
                        return [4 /*yield*/, ESRI.PictureMarker];
                    case 2:
                        PictureMarkerSymbol = _c.sent();
                        pin = this.graphic.clone();
                        pin.symbol = new PictureMarkerSymbol(this.nearbyAssetPointSymbol);
                        graphics = [pin];
                        _c.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        this.distance = this.distance === this.distanceDefaultPtLn ? 0 : this.distance;
                        return [3 /*break*/, 6];
                    case 5: return [3 /*break*/, 6];
                    case 6:
                        this.nearbyService.setNearbyLayer(this.nearbyService.nearbyLayers.mapPin, graphics);
                        this.loaderText = 'Setting nearby searching area...';
                        return [4 /*yield*/, this.nearbyService.getBuffers(this.distance, this.distanceUnit, [this.graphic.geometry])];
                    case 7:
                        buffers = _c.sent();
                        totalArea = buffers.reduce(function (area, buffer) {
                            area += buffer.area;
                            return area;
                        }, 0);
                        if (!(totalArea > this.areaMax)) return [3 /*break*/, 8];
                        window.alert('Nearby Assets Search Area too large.');
                        return [3 /*break*/, 12];
                    case 8:
                        buffer = buffers.map(function (b) { return b.graphic; });
                        this.tree = new Tree(new NearbyAssetNode({ name: 'Assets' }));
                        this.loaderText = 'Searching for nearby assets...';
                        _b = this;
                        return [4 /*yield*/, this.nearbyService.getApplicationNearbyAssets(environment.appId)];
                    case 9:
                        _b.assets = _c.sent();
                        return [4 /*yield*/, this.nearbyService.setNearbyLayer(this.nearbyService.nearbyLayers.selection, buffer)];
                    case 10:
                        selectionLayer = _c.sent();
                        heightOrWithThreshold = 2000;
                        zoomThreshold = 16;
                        this.layerService.zoomToTarget(buffer.flatMap(function (x) { return x.geometry; }), heightOrWithThreshold, zoomThreshold);
                        this.loaderText = 'Generating results...';
                        return [4 /*yield*/, this.navigateToNode(this.tree, this.assets, selectionLayer)];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12: return [3 /*break*/, 15];
                    case 13:
                        error_1 = _c.sent();
                        this.LoggingService.Log(error_1, LogLevel.Error);
                        return [3 /*break*/, 15];
                    case 14:
                        this.loading = false;
                        this.status.emit('loaded');
                        return [7 /*endfinally*/];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.navigateToNode = function (node, assets, selection) {
        if (selection === void 0) { selection = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var columns, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.currentNode = node;
                        return [4 /*yield*/, this.buildTree(node, assets, selection)];
                    case 1:
                        _a.sent();
                        if (node.children.length > 0) {
                            this.asc = node.data.asc || true;
                            if (node.data.orderBy) {
                                this.orderBy = node.data.orderBy;
                            }
                            else {
                                columns = this.nearbyService.getSortableColumns(node);
                                if (columns.length) {
                                    if (node.children && node.children.length > 0 && node.children[0].data.nodeType === NodeType.Document) {
                                        this.orderBy = 'documentClass';
                                    }
                                    else {
                                        this.orderBy = columns[0].name;
                                    }
                                }
                                else {
                                    this.orderBy = undefined;
                                }
                            }
                            this.showPrimary = true;
                            this.showSecondary = true;
                            this.sortChildren(node, this.orderBy, this.asc);
                            this.showAssetsOnMap(node.children);
                            this.cdr.detectChanges();
                        }
                        else {
                            this.currentNode = node.parent; // Didn't find data, return user to parent node
                        }
                        return [2 /*return*/, this.currentNode];
                    case 2:
                        error_2 = _a.sent();
                        this.LoggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.buildTree = function (node, assets, selection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, data, layer, layers, query, parentRecord, columns, records, childrenAssets, tasks, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        data = node.data;
                        if (!!node.children.length) return [3 /*break*/, 15];
                        node.loading = true;
                        if (!(data.layerId || data.tableId)) return [3 /*break*/, 12];
                        layer = void 0;
                        if (!data.layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerService.getLayers([data.layerId])];
                    case 1:
                        layers = _d.sent();
                        layer = layers.filter(function (x) { return x.mapcoreProps.parentId === data.layerId; })[0];
                        _d.label = 2;
                    case 2:
                        query = void 0;
                        parentRecord = this.nearbyService.findKeyParent(node);
                        if (!parentRecord) return [3 /*break*/, 3];
                        query = this.nearbyService.getJoinQuery(parentRecord, node);
                        return [3 /*break*/, 5];
                    case 3:
                        if (!layer) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.nearbyService.performSpatialQuery(layer, selection)];
                    case 4:
                        query = _d.sent();
                        _d.label = 5;
                    case 5:
                        if (!query) return [3 /*break*/, 10];
                        columns = void 0, records = void 0;
                        if (!data.layerId) return [3 /*break*/, 7];
                        this.nearbyService.updateLayerFilter(layer, query);
                        return [4 /*yield*/, this.nearbyService.getLayerRecords(layer, data.columnList)];
                    case 6:
                        (_a = _d.sent(), columns = _a.columns, records = _a.records);
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.nearbyService.getTableRecords(data.tableId, query, data.columnList)];
                    case 8:
                        (_b = _d.sent(), columns = _b.columns, records = _b.records);
                        _d.label = 9;
                    case 9:
                        data.columns = columns;
                        this.nearbyService.addRecordNodes(node, data.columnList, records);
                        data.enabled = !!node.children.length;
                        return [3 /*break*/, 11];
                    case 10:
                        // no query means the current node shouldn't be shown to the user. Typically due to permissions (for layers)
                        node.remove(node.name);
                        _d.label = 11;
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        childrenAssets = assets.filter(function (a) { return a.parentId === data.id; });
                        childrenAssets.forEach(function (asset) { return node.addChild(new NearbyAssetNode(tslib_1.__assign({ name: asset.relationshipName }, asset))); });
                        tasks = node.children.map(function (child) { return _this.buildTree(child, assets, selection); });
                        tasks.push(this.fetchDocuments(node));
                        _c = data;
                        return [4 /*yield*/, this.anyTrue(tasks)];
                    case 13:
                        _c.enabled = _d.sent();
                        _d.label = 14;
                    case 14:
                        node.loading = false;
                        _d.label = 15;
                    case 15:
                        this.cdr.detectChanges();
                        return [2 /*return*/, data.enabled];
                }
            });
        });
    };
    NearbyComponent.prototype.fetchDocuments = function (node) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, docNode, documents;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!node.data.record) return [3 /*break*/, 6];
                        _a = node.parent.data;
                        _b = node.parent.data.sources;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nearbyService.getDocumentSources(node)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        _a.sources = _b;
                        if (!node.parent.data.sources.length) return [3 /*break*/, 6];
                        node.addChild(new NearbyAssetNode({ name: 'Documents' }));
                        docNode = node.children.filter(function (n) { return n.data.name === 'Documents'; })[0];
                        docNode.loading = true;
                        return [4 /*yield*/, this.nearbyService.getDocuments(node, node.parent.data.sources)];
                    case 3:
                        documents = _c.sent();
                        if (!documents.length) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.nearbyService.addDocumentNodes(docNode, documents)];
                    case 4:
                        _c.sent();
                        docNode.name = "Documents (" + docNode.children.length + ")";
                        docNode.data.enabled = true;
                        node.data.enabled = true;
                        _c.label = 5;
                    case 5:
                        docNode.loading = false;
                        _c.label = 6;
                    case 6: return [2 /*return*/, true];
                }
            });
        });
    };
    NearbyComponent.prototype.anyTrue = function (promises) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newPromises;
            return tslib_1.__generator(this, function (_a) {
                newPromises = promises.map(function (p) {
                    return new Promise(function (resolve, reject) { return p.then(function (v) { return v && resolve(true); }, reject); });
                });
                newPromises.push(Promise.all(promises).then(function () { return false; }));
                return [2 /*return*/, Promise.race(newPromises)];
            });
        });
    };
    NearbyComponent.prototype.showAssetsOnMap = function (children) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, graphics, defaultSymbol, children_1, children_1_1, child, data, idx, geometries, geometry, e_1_1, layer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _b.sent();
                        graphics = [];
                        defaultSymbol = 'default';
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 8, 9, 10]);
                        children_1 = tslib_1.__values(children), children_1_1 = children_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!children_1_1.done) return [3 /*break*/, 7];
                        child = children_1_1.value;
                        data = child.data;
                        if (!(!data.graphic && data.record && data.nodeType === NodeType.Record)) return [3 /*break*/, 5];
                        idx = data.columnList.indexOf('GEOMETRY');
                        if (!(idx >= 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.layerService.convertGeometry([data.record[idx]])];
                    case 4:
                        geometries = _b.sent();
                        geometry = geometries[0];
                        data.graphic = new Graphic({
                            geometry: geometry,
                            symbol: this.nearbyAssetSymbols[geometry.type] || this.nearbyAssetSymbols[defaultSymbol]
                        });
                        if (geometry.type === 'point') {
                            data.lngLat = WebMercatorUtils.xyToLngLat(geometry.x, geometry.y);
                        }
                        else {
                            data.lngLat = WebMercatorUtils.xyToLngLat(geometry.paths[0][0][0], geometry.paths[0][0][1]);
                        }
                        _b.label = 5;
                    case 5:
                        if (data.graphic) {
                            graphics.push(data.graphic);
                        }
                        _b.label = 6;
                    case 6:
                        children_1_1 = children_1.next();
                        return [3 /*break*/, 3];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [4 /*yield*/, this.nearbyService.setNearbyLayer(this.nearbyService.nearbyLayers.assets, graphics)];
                    case 11:
                        layer = _b.sent();
                        if (graphics.length > 0) {
                            this.layerService.moveLayerToTheTop(layer);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.highlightNode = function (node) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defaultSymbol, highlights, highlight, layer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defaultSymbol = 'default';
                        highlights = [];
                        if (node.data.graphic) {
                            highlight = node.data.graphic.clone();
                            highlight.symbol = this.highlightSymbols[node.data.graphic.geometry.type] || this.highlightSymbols[defaultSymbol];
                            highlights.push(highlight);
                        }
                        return [4 /*yield*/, this.nearbyService.setNearbyLayer(this.nearbyService.nearbyLayers.highlight, highlights)];
                    case 1:
                        layer = _a.sent();
                        this.layerService.moveLayerToTheTop(layer);
                        this.layerService.moveLayerToTheTop(this.nearbyService.getNearbyLayer(this.nearbyService.nearbyLayers.mapPin));
                        return [2 /*return*/];
                }
            });
        });
    };
    NearbyComponent.prototype.orderByChange = function (orderBy) {
        this.orderBy = orderBy;
        this.sortChildren(this.currentNode, orderBy, this.asc);
    };
    NearbyComponent.prototype.changeOrder = function () {
        this.asc = !this.asc;
        this.sortChildren(this.currentNode, this.orderBy, this.asc);
    };
    NearbyComponent.prototype.sortChildren = function (node, orderBy, asc) {
        this.groups = null;
        var sortOrder = asc ? 1 : -1;
        var collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
        if (orderBy) {
            switch (node.children[0].data.nodeType) {
                case NodeType.Record:
                    this.groups = this.buildGroups(node, orderBy);
                    this.groups.sort(function (a, b) { return sortOrder * collator.compare(a[0].split(': ')[1], b[0].split(': ')[1]); });
                    break;
                case NodeType.Document:
                    var alias_1 = node.data.columns.find(function (c) { return c.name === orderBy; }).alias;
                    // TODO: Consider making documents data.records the same as Record nodes have.
                    //       Just need data.columnList and change data.records to an array of strings.
                    var groups = node.children.reduce(function (acc, child) {
                        (acc[alias_1 + ": " + child.data.record[orderBy]] = acc[alias_1 + ": " + child.data.record[orderBy]] || []).push(child);
                        return acc;
                    }, {});
                    this.groups = Object.entries(groups);
                    this.groups.sort(function (a, b) { return sortOrder * collator.compare(a[0].split(': ')[1], b[0].split(': ')[1]); });
                    break;
                default:
                    var idx_1 = node.children[0].data.columnList.indexOf(orderBy);
                    if (idx_1 <= 0) {
                        var column = node.data.columns.find(function (c) { return c.alias = orderBy; });
                        idx_1 = node.children[0].data.columnList.indexOf(column.name);
                    }
                    node.children.sort(function (a, b) { return sortOrder * collator.compare(a.data.record[idx_1], b.data.record[idx_1]); });
            }
        }
        else {
            node.children.sort(function (a, b) { return sortOrder * collator.compare(a.name, b.name); });
        }
        this.currentNode.data.asc = asc;
        this.currentNode.data.orderBy = orderBy;
        this.cdr.detectChanges();
    };
    NearbyComponent.prototype.buildGroups = function (node, primaryKey) {
        var column = node.data.columns.find(function (c) { return c.name === primaryKey; });
        var alias = column ? column.alias : primaryKey;
        var groups = node.children.reduce(function (acc, child) {
            var map = child.data.columnList.reduce(function (map, column, idx) {
                map[column] = child.data.record[idx];
                return map;
            }, {});
            (acc[alias + ": " + map[primaryKey]] = acc[alias + ": " + map[primaryKey]] || []).push(child);
            return acc;
        }, {});
        return Object.entries(groups);
    };
    return NearbyComponent;
}(BaseComponent));
export { NearbyComponent };
